module.exports = __webpack_public_path__ + "img/latestversionofYoWhatsAppDownload.e471585f.webp";